<!--
SvgIcon 组件：通用 SVG 图标组件

功能：
- 动态渲染 SVG 图标，支持自定义颜色、大小和图标类名。

Props：
- `prefix` (String)：图标前缀，默认值为 "icon"。
- `iconClass` (String)：图标类名，默认为空字符串。
- `color` (String)：图标颜色，默认为空字符串（继承父元素颜色）。
- `size` (String)：图标大小，默认值为 "1em"。

特点：
- 通过 `symbolId` 计算属性生成完整的图标 ID。
- 支持 CSS `currentColor`，自动继承父级元素的字体颜色。

使用示例：
```vue
<svg-icon icon-class="user" color="#333" size="24px" />
-->
<template>
    <svg aria-hidden="true" class="svg-icon" :style="'width:' + size + ';height:' + size">
      <use :xlink:href="symbolId" :fill="color" />
    </svg>
  </template>
  
  <script setup>
  import { computed } from "vue"
  const props = defineProps({
    prefix: {
      type: String,
      default: "icon",
    },
    iconClass: {
      type: String,
      required: false,
      default: "",
    },
    color: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "1em",
    },
  })
  
  const symbolId = computed(() => `#${props.prefix}-${props.iconClass}`)
  </script>
  
  <style scoped>
  .svg-icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    overflow: hidden;
    vertical-align: -0.15em; /* 因icon大小被设置为和字体大小一致，而span等标签的下边缘会和字体的基线对齐，故需设置一个往下的偏移比例，来纠正视觉上的未对齐效果 */
    outline: none;
    fill: currentcolor; /* 定义元素的颜色，currentColor是一个变量，这个变量的值就表示当前元素的color值，如果当前元素未设置color值，则从父元素继承 */
  }
  </style>
  